export default __webpack_public_path__ + "static/media/linux.09fc32f1.png";